import React from 'react';
import ActionButton from '../../action-button';

const BuyDomainButton = (props) => (
  <div className="ws-ui-editor-header__buy-domain-btn">
    <ActionButton {...props} format="solid-white" size="small" appearance="cta" />
  </div>
);

export default BuyDomainButton;
